// Información de build generada automáticamente
export const BUILD_DATE = '13-07-2026 19:12:17';
export const BUILD_HASH = 'it5y1ogtp2';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1783980737870;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '13-07-2026 19:12:17',
  buildHash: 'it5y1ogtp2',
  appVersion: '0.0.0',
  timestamp: 1783980737870
});
